namespace Core.Trip {

    export enum TripType {
        None = 0,
        Flight = 1,
        Hotel = 2,
        Transfer = 3,
        Holiday = 4,
        Marhaba = 5,
        AirportParking = 6,
        Attractions = 7,
        DynamicPackage = 8,
        Insurance = 9
    }

    export interface TripState {
        TripType: TripType;
        HotelsRequest?: HotelsRequest;
        FlightsRequest?: FlightsRequest;
        MultiFlightsRequest?: MultiFlightsRequest;
        TransfersRequest?: TransfersRequest;
        MarhabaRequest?: MarhabaRequest;
        InsuranceRequest?: InsuranceRequest;
        CarHireRequest?: CarHireRequest;
        ParkingRequest?: ParkingRequest;
        AttractionRequest?: AttractionRequest;
        MultiDestinationFlightRequests?: FlightsRequest[];
        TripId: string;
        BasketId?: string;
        BookingId?: string;
        Deal?: Deal;
        QuoteId?: string;
        FromHolidayDeal: boolean;
        PackageId: string;
        IsKidsFree: boolean;
    }

    export interface HotelsRequest {
        AvailabilitySearchId?: string;
        Destination?: Destination;
        SearchArea?: SearchArea;
        CheckInDate: string;
        CheckOutDate: string;
        Rooms: Occupancy[];
        DirectToHotel: boolean;
        CurrencyCode?: string;
    }

    export interface FlightsRequest {
        AvailabilitySearchId?: string;
        Destination?: Destination;
        Adults: number;
        Cabin: number;
        ChildAges?: number[];
        DepartureDate: string;
        ReturnDate?: string;
        SelectedDepartureAirport?: Airport;
        SelectedDestinationAirport?: Airport;
        OneWayOnly: boolean;
        SelectedFlight?: SelectedFlight;
        PreferredCarrierCodes?: string[];
    }

    export interface MultiFlightsRequest {
        AvailabilitySearchId?: string;
        Adults: number;
        Cabin: number;
        ChildAges?: number[];
        FlightRoutes?: FlightRoute[];
    }

    export interface TransfersRequest {
        AvailabilitySearchId?: string;
        AirportCode?: string;
        Route?: TransferRoute;
        ResortId: number;
        ResortTitle?: string;
        LocationId: number;
        ArrivalDate?: string;
        ReturnDate?: string;
        Adults: number;
        ChildAges?: number[];
        DestinationAirport?: Airport;
    }

    export interface MarhabaRequest {
        AvailabilitySearchId?: string;
        Terminal?: Terminal;
        Airport?: Airport;
        DateAndTime: string;
        FlightType: number;
        Occupancy: Occupancy;
    }

    export interface InsuranceRequest {
        AvailabilitySearchId?: string;
        AirportCode?: string;
        StartDate: string;
        EndDate: string;
        Ages?: number[];
        PolicyType: PolicyType;
        PolicyExtras: PolicyExtra[];
        TravelDestination: TravelDestination;
    }

    export interface PolicyExtra {
        Id: number;
        Name?: string;
    }

    export interface TravelDestination {
        Id: number;
        Name?: string;
    }

    export interface PolicyType {
        Id: number;
        Name?: string;
    }

    export interface CarHireRequest {
        AvailabilitySearchId?: string;
        DropOffLocation: {
            Code: string;
            Type: number;
        };
        PickUpLocation: {
            Code: string;
            Type: number;
        };
        PickUpDate: string;
        DropOffDate: string;
        DriverAge: number;
    }

    export interface ParkingRequest {
        AvailabilitySearchId?: string;
        Airport?: Airport;
        DepartureDate: string;
        ReturnDate: string;
        PassengerCount: number;
        DepartureTerminalCode?: string;
    }

    export type AttractionRequest = any;

    export interface Deal {
        DealId: number;
        EstablishmentId: number;
        OriginPath?: string;
        Sale: boolean;
    }

    export interface Destination {
        Type: Destinations.DestinationType;
        Id: number;
        CountryId: number;
        ProvinceId: number;
        LocationId: number;
        PlaceId: number;
        EstablishmentId: number;
        PolygonId: number;
    }

    export interface SearchArea {
        Latitude: number;
        Longitude: number;
        Radius: number;
    }

    export interface Airport {
        Code?: string;
        Title?: string;
        ShortTitle?: string;
    }

    export interface SelectedFlight {
        FlightId?: string;
        DetailsId?: string;
        LeadAdultPrice: number;
        LeadAdultTax: number;
        LeadBaggagePrice: number;
        BaggageCount: number;
        AllBagsOrNone: boolean;
    }

    export interface TransferRoute {
        PickUpPoint?: EndPoint;
        DropOffPoint?: EndPoint;
    }

    export interface Terminal {
        Id: number;
        Name?: string;
        TerminalNumber?: string;
    }

    export interface Occupancy {
        Adults: number;
        Children: number;
        Infants: number;
        ChildAges?: number[];
    }

    export interface EndPoint {
        Type: any;
        Code?: string;
        Title?: string;
        Description?: string;
    }

    export interface FlightRoute {
        DepartureDate: string;
        DepartureAirport?: string;
        DestinationAirport?: string;
    }

    export interface TripFromQuoteRequest {
        QuoteId?: string;
        BasketId?: string;
        ForHoliday: boolean;
        HotelsRequestId?: string;
        FlightsRequestId?: string;
        AttractionsRequestId?: string;
        CarHireRequestId?: string;
        InsuranceRequestId?: string;
        MarhabaRequestId?: string;
        ParkingRequestId?: string;
        TransfersRequestId?: string;
    }

    export interface TripFromQuoteResponse {
        TripId?: string;
        BookingId?: string;
    }

    export interface TripFromDealRequest {
        AvailabilitySearchId: string;
        EstablishmentId: number;
        Deal?: DealRequest;
        DealId: number;
        OriginPath?: string;
        DomainId: number;
    }

    export interface TripFromDealResponse {
        TripId?: string;
    }

    export interface DealRequest {
        Id: number;
        DomainId: number;
        EstabId: number;
        CheckInDate: string;
        Duration: number;
        Adults: number;
        Children: number;
        Infants: number;
        Price: number;
        TagIds?: number[];
        SortWeight: number;
        PriceUpdated: string;
        AvailabilitySearchId?: string;
        Sale: boolean;
    }

}
